import { render, staticRenderFns } from "./mims.html?vue&type=template&id=6273b454&scoped=true&external"
import script from "./mims.vue?vue&type=script&lang=js"
export * from "./mims.vue?vue&type=script&lang=js"
import style0 from "./mims.vue?vue&type=style&index=0&id=6273b454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273b454",
  null
  
)

export default component.exports